module.exports = __webpack_public_path__ + "img/scope-social.797de807.png";